// La boîte « À valider » : les propositions d'Alfred (et, plus tard, les autorisations demandées par un
// client MCP). La notification « Alfred propose » ouvre cet écran.

import { useCallback, useEffect, useState } from 'react';

import type { Actions } from '../App';
import { EnTeteRetour, Fenetre, Nav } from '../components';
import { type Demande, NonConnecte, api } from '../lib/api';

export function AValider({ actions, sante }: { actions: Actions; sante: boolean }) {
  const [demandes, setDemandes] = useState<Demande[] | null>(null);

  const charger = useCallback(() => {
    api.demandes().then(setDemandes).catch((e: Error) => {
      if (e instanceof NonConnecte) window.location.hash = '#/connexion';
      else actions.toast({ texte: e.message, erreur: true });
    });
  }, [actions]);

  useEffect(charger, [charger]);

  const repondre = async (id: string, accepte: boolean) => {
    if (await actions.repondre(id, accepte)) charger();
  };

  return (
    <main className="ecran avec-nav">
      <EnTeteRetour titre="À valider" />
      {demandes === null && <p className="message muted">Chargement…</p>}
      {demandes?.length === 0 && <p className="message muted">Rien à valider.</p>}
      {demandes?.map((d) => (
        <Fenetre key={d.id}>
          <span className="mono muted" style={{ fontSize: 11 }}>{d.auteur} · {new Date(d.creeLe).toLocaleDateString('fr-FR')}</span>
          <p className="message" style={{ fontSize: 14, margin: 0 }}><strong>{d.titre}</strong></p>
          {d.detail && <p className="muted" style={{ margin: 0, fontSize: 13, lineHeight: 1.45, whiteSpace: 'pre-line' }}>{d.detail}</p>}
          <div className="boutons">
            <button className="btn principal" onClick={() => void repondre(d.id, true)}>Accepter</button>
            <button className="btn" onClick={() => void repondre(d.id, false)}>Refuser</button>
          </div>
        </Fenetre>
      ))}
      <Nav actif="brief" sante={sante} />
    </main>
  );
}
